import { useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import logoImage from "../images/Egasi-logo.png";
import notificationsAsset from "../images/Group 11680.png";
import languageAsset from "../images/Group 11819.png";
import profile from "../images/profile.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import strings from "../utils/locals/languages";
import { setLanguage } from "../slices/languageSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import apiClient from "../utils/apiClient";
import Avatar from "@mui/material/Avatar";

import EnglishFlag from '../images/english.png'
import RussianFlag from '../images/russian.png'
import uzbekFlag from '../images/uzbek.png'
import AdCreateModal from '../pages/home/AdCreateModal'
import { setNotifications } from "../slices/notificationsSlice";
import DeleteUserModal from "./DeleteUser";
import { countUnreadNotifications } from "../utils/notificationsCount";
import AuthModal from "./AuthModal";
import NotificationsConvas from "./NotificationsCanvas";
import { toggleState } from "../methods/handlers";
import menuItems from "../constants/menuItems";
import { resetGlobalData } from "../slices/globalDataSlice";


const Header = () => {

  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [showCreateAdModal, setShowCreateAdModal] = useState(false)
  const [profileData, setProfileData] = useState({});
  const [profileMenu, setProfileMenu] = useState(false);
  const button1Ref = useRef(null);


  const dispatch = useDispatch();

  const token = Cookies.get("token");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const readNotification = async () => {
    await apiClient.put(`/v1/user/read-notifications`);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const logOutUser = () => {
    Cookies.remove("token");
    Cookies.remove("userDetails");
    toast.success("Logout Successfull!");

    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  const [isAuthModal, setIsAuthModal] = useState(false);

  const handleLanguageChange = (language) => {
    strings.setLanguage(language);
    dispatch(setLanguage(language));
    dispatch(resetGlobalData());

    Cookies.set("language", language);
    setTimeout(() => {
      window.location.reload();
    }, 500);
   
  };

  useEffect(() => {
    const selectedLanguage = Cookies.get("language");

    if (selectedLanguage !== undefined) {
      strings.setLanguage(selectedLanguage);
    }
  }, []);

  const handleShow = () => setIsAuthModal(true);



  const fetchNotifications = async () => {
    try {
      const response = await apiClient.get("/v1/user/notification")
      const notifications = response.data;

      const userDetails = Cookies.get("userDetails")

      const user = JSON.parse(userDetails);

      const notificationsCount = countUnreadNotifications(notifications, user._id)

      setUnreadNotificationsCount(notificationsCount)

      dispatch(setNotifications(notifications));
    } catch (error) {
      dispatch(setNotifications([]));
    }
  };

  useEffect(() => {
    fetchNotifications()
  }, []);


  const navigate = useNavigate();

  const notifications = useSelector(state => state.notifications.notifications);

  useEffect(() => {
    const userDetails = Cookies.get("userDetails");
    if (userDetails) {
      const user = JSON.parse(userDetails);
      const {
        name,
        companyName,
        phone,
        email,
        country,
        city,
        logo,
        address,
        image,
        taxNumber,
        officePhone,
        gender,
      } = user;
      const filteredUser = {
        name,
        companyName,
        phone,
        email,
        country,
        city,
        logo,
        address,
        image,
        taxNumber,
        officePhone,
        gender,
      };
      setProfileData(filteredUser);
    } else {
      setProfileData("Null");
    }
  }, []);

  return (
    <>
      <Navbar collapseOnSelect expand="lg">
        <Container className="lg:h-[100px]">
          <Navbar.Brand className="col-8  flex justify-start">
          <Link to="/" className="h-max  ">
          <img src={logoImage} alt="" className=" w-[180px]" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav " className="col-4 ">


            <Nav className="ms-auto md:p-0 p-2  flex h-max items-center w-[100%] justify-end">

              <Link to="/">
                <button className="text-orange-400 ml-1">{strings.home}</button>
              </Link>

              {token === undefined ? (
                <Nav.Link eventKey={2}>
                  <div
                    className="border-1 p-[6px] px-[12px] rounded-full border-[#F37521] text-white bg-[#F37521] cursor-pointer whitespace-nowrap inline-bloc"
                    onClick={handleShow}
                  >
                    {strings.login}
                  </div>
                </Nav.Link>
              ) : (
                <Nav.Link>
                  {profileData !== "Null" ? (
                    <Avatar
                      alt="Travis Howard"
                      src={
                        profileData.image === "" ? profile : profileData.image
                      }
                      style={{
                        height: 60,
                        width: 60,
                      }}
                      onClick={() => toggleState(setProfileMenu)}
                      ref={button1Ref}
                    />
                  ) : (
                    <Avatar
                      alt="Travis Howard"
                      src=""
                      style={{
                        height: 50,
                        width: 50,
                        marginTop: 7,
                      }}
                      onClick={() => toggleState(setProfileMenu)}
                      ref={button1Ref}
                    />
                  )}
                </Nav.Link>
              )}

              {
                token !== undefined && (
                  <div
                    className="w-max"
                  >
                    <div
                      onClick={() => setShowCreateAdModal(true)}
                      className="w-max border-2 rounded-full bg-transparent text-[#f37521] border-[#f37521] p-2 cursor-pointer "
                    >
                      {strings.createAd}
                    </div>
                  </div>
                )
              }
              {
                showCreateAdModal && (
                  <AdCreateModal showCreateAdModal={showCreateAdModal} setShowCreateAdModal={setShowCreateAdModal} />
                )
              }
              <Menu anchorEl={button1Ref.current} open={Boolean(profileMenu)} onClose={() => toggleState(setProfileMenu)}>
                {menuItems.map((item, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      if (item.requiresAuth && (token === null || token === undefined)) {
                        toast.warn(item.warning);
                      } else {
                        item.path && navigate(item.path);
                        item.action === "deleteAccount" && setShowDeleteConfirmation(true);
                        item.action === "toggleAuth" && (token === undefined ? handleShow() : logOutUser());
                      }
                      toggleState(setProfileMenu);
                    }}
                    className={item.extra ? "flex justify-between" : ""}
                  >
                    <div>{item.label}</div>
                    {item.extra && <span className="text-orange-400 ml-2">{item.extra}</span>}
                  </MenuItem>
                ))}
              </Menu>

              <Nav.Link
                className="relative flex items-center bg-red-600"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"

                onClick={() => readNotification()}
              >
                <span className="sr-only">{strings.notif}</span>
                {
                  unreadNotificationsCount.length > 0 && (
                    <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -right-1 dark:border-gray-900">
                      {unreadNotificationsCount}
                    </div>
                  )
                }
                <img className="w-[50px] cursor-pointer mt-2 h-[50px]" src={notificationsAsset} alt="" />
              </Nav.Link>

              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  onClick={() => {
                    // selectLanguage("en")
                    handleLanguageChange("en");
                    handleMenuClose();
                  }}
                  style={{
                    backgroundColor:
                      Cookies.get("language") === "en" ? "#F37521" : "",
                    color: Cookies.get("language") === "en" ? "#fff" : "",
                  }}
                >
                  <img src={EnglishFlag} alt="Eng Flag" className="h-[20px] mr-2" />
                  English
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    // selectLanguage("ru")
                    handleLanguageChange("ru");
                    handleMenuClose();
                  }}
                  style={{
                    backgroundColor:
                      Cookies.get("language") === "ru" ? "#F37521" : "",
                    color: Cookies.get("language") === "ru" ? "#fff" : "",
                  }}
                >
                  <img src={RussianFlag} alt="Russian Flag" className="h-[20px] mr-2" />
                  Русский
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    // selectLanguage("uz")
                    handleLanguageChange("uz");
                    handleMenuClose();
                  }}
                  style={{
                    backgroundColor:
                      Cookies.get("language") === "uz" ? "#F37521" : "",
                    color: Cookies.get("language") === "uz" ? "#fff" : "",
                  }}
                >
                  <img src={uzbekFlag} alt="Uz Flag" className="h-[20px] mr-2" />
                  O'zbek
                </MenuItem>
              </Menu>

              <img
                className="w-[50px] mt-2 cursor-pointer h-[50px]"
                src={languageAsset}
                alt=""
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              />
            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>



      {
        isAuthModal && <AuthModal show={isAuthModal} setShow={setIsAuthModal} />
      }

      <NotificationsConvas notificationData={notifications} />

      {
        showDeleteConfirmation && <DeleteUserModal showDeleteConfirmation={showDeleteConfirmation} setShowDeleteConfirmation={setShowDeleteConfirmation} />
      }
    </>
  );
};

export default Header;
